export default "__VITE_ASSET__B$FLeJwd__"